import { Asset } from '@/types/assets'

export const getHasAssetAnyResult = (asset: Asset) => {
  const personalEmail = asset.singleEnrichment?.enrichedEmail
  const workEmail = asset.singleEnrichment?.enrichedWorkEmail
  const personalPhone = asset.singleEnrichment?.enrichedPhone

  return !!personalEmail || !!workEmail || !!personalPhone
}
